import ADPParamService from "../../../services/admin/ADPParamService";
import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import ASTInstrumentService from "../../../services/ast/ASTInstrumentService";
import ASTQrdetService from "../../../services/ast/ASTQrdetService";
import ASTQrService from "../../../services/ast/ASTQrService";
import ASTSparepartService from "../../../services/ast/ASTSparepartService";

class sparepartService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async setSearchParam(recordFilter: any, pathName: any): Promise<any> {
        let param = { recordFilter };
        localStorage.setItem(pathName, JSON.stringify(param));
    }

    async getSearchParam(pathName: any): Promise<any> {
        const searchParam = localStorage.getItem(pathName);
        return searchParam ? JSON.parse(searchParam) : null
    }

    async findAll(recordFilter: any): Promise<any> {
        return await ASTSparepartService.findAll(recordFilter);
    }

    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async create(item: any): Promise<any> {
        return await ASTSparepartService.create(item);
    }

    async update(item: any): Promise<any> {
        return await ASTSparepartService.update(item.sparepartId, item);
    }

    async getPrinterName(parameterId: string): Promise<any> {
        return await ADPParamService.getItemById(parameterId);
    }

    async instock(item: any): Promise<any> {
        return await ASTSparepartService.instock(item);
    }

    async outstock(item: any): Promise<any> {
        return await ASTSparepartService.outstock(item);
    }

}

export default new sparepartService();
